import { defineStore } from 'pinia'

export const useSearchResultsMapStore = defineStore('search_results_map', {
  state: () => ({
    fullSize: false,
    moveMapSearch: false,
    visible: true,
    search: true,
    lastOpenObject: null,
    isAppleDevice: false,
    mapModalOpen: false,
    isSpin: false,
    preservePageOnNextLimitsChange: false,
    moveMapIteration: 0,
    hoveredObject: null
  })
})
